import { Shield } from 'lucide-react';
import { NavLink } from '@/components/NavLink';
import { AlertBanner } from './AlertBanner';

/*
 * The pre-rollout wording, kept from the original file:
 *   We are implementing two factor authentication to better secure our platform.
 *   Please <NavLink to="/settings/account">set up your passkeys</NavLink> to continue.
 */
export function TwoFactorAlert({ onClose }: { onClose?: () => void }) {
  return (
    <AlertBanner icon={Shield} chip="Security" heading="Two-Factor Authentication" onClose={onClose}>
      Enable passkeys for a faster, more secure way to sign in. No passwords required.{' '}
      <NavLink className="text-accent hover:underline" to="/settings/account">
        Set up passkeys
      </NavLink>
    </AlertBanner>
  );
}
